export default (number, haveDecimals) => {
    let formatedStringNumber = number.toString();
    if (haveDecimals) {
        formatedStringNumber = (Math.round(number * 100) / 100).toFixed(2).toString();
    }
    return formatedStringNumber.replace(/(?!^)(?=(?:\d{3})+(?:\.|$))/gm, " ");
};